import { render } from "./MobileBottomNav.vue?vue&type=template&id=2d3a7344"
import script from "./MobileBottomNav.vue?vue&type=script&lang=js"
export * from "./MobileBottomNav.vue?vue&type=script&lang=js"

import exportComponent from "E:\\DeepakKumarJha\\TfsProjects\\BrikTok\\SpliytGit\\SpliytAdminPortal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__